import {Navigate} from "react-router-dom";
import {useContext} from "react";
import PermissionsContext from "../../utils/context";

// For routes that can only be accessed by authenticated users
function PermissionGuard({children, role}) {
    const {permissions} = useContext(PermissionsContext)

    if (!permissions.includes(role)) {
        return <Navigate to="/error" state={{code: 403, message: "U heeft niet de juiste machtigingen voor deze pagina"}}/>;
    }

    return <>{children}</>;
}

export default PermissionGuard;
